import { Component, EventEmitter, HostBinding, Output } from "@angular/core";

@Component({
    selector: "sps-focused-task",
    templateUrl: "./sps-focused-task.component.html",
})
export class SpsFocusedTaskComponent {
    static readonly displayName = "sps-focused-task";
    static readonly props = {
        close: { event: true, type: "void" },
    };

    @HostBinding("class.sps-focused-task") readonly focusedTaskClass = true;
    @HostBinding("class.z-stratum-dialog") readonly zStratumDialogClass = true;

    @HostBinding("class.sps-focused-task--open") _isOpen = false;

    // tslint:disable no-output-rename
    @Output("close") closeEvent = new EventEmitter<void>();
    // tslint:enable no-output-rename

    open() {
        if (!this._isOpen) {
            this._isOpen = true;
        }
    }

    close() {
        if (this._isOpen) {
            this._isOpen = false;
            this.closeEvent.emit();
        }
    }

    toggle() {
        if (this._isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
}
